export const formatTutorLoad = (tutor: {
    fullName: string;
    desiredHours?: string;
    actualHours?: string;
}) => `План/факт: ${tutor.desiredHours || '—'}/${tutor.actualHours || '0'}`

export const formatTutorConversion = (
    conversion: number,
    conversionBase?: number | string,
    closedCount?: number | string,
    lostCount?: number | string,
): string => {
    const breakdown = closedCount !== undefined && lostCount !== undefined ? ` (${closedCount}/${lostCount})` : ''
    if(conversionBase !== undefined && Number(conversionBase) === 0){
        return `Конверсия: —${breakdown}`
    }

    const percent = Number.isFinite(conversion) ? Math.round(conversion * 100) : 0
    return `Конверсия: ${percent}%${breakdown}`
}
